import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const savedTheme = localStorage.getItem('ms-digitais-theme');
if (savedTheme === 'dark' || savedTheme === 'light') {
  document.documentElement.classList.add(savedTheme);
} else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.add('light');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
